import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  createHttpLink
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Stack } from '@jarvis/web-stratus-client';
import getEnvironmentVariables from 'src/helpers/getEnvironmentVariables';
import { getStack } from 'src/helpers/getStack';

export const createApolloClient = (authToken: any, stack: Stack) => {
  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: authToken ? `Bearer ${authToken}` : ''
      }
    };
  });

  const env = getEnvironmentVariables(getStack(stack));
  const httpLink = createHttpLink({
    uri: env?.variables?.APOLLO_GRAPHGQL
  });

  const client = new ApolloClient({
    link: ApolloLink.from([authLink, httpLink]),
    cache: new InMemoryCache()
  });

  return client;
};
